import { Spinner } from "@/components/spinner/spinner";
import { DashboardRoutes } from "@/constants/routes";
import { useAuth } from "@/context/auth/useAuth";
import { featuresService } from "@/services/featuresService";
import { authSession } from "@/utils/authSession";
import { buildLoginPath } from "@/utils/loginRedirect";
import { Navigate, Outlet, useLocation } from "react-router";

export const BackofficeRoute = () => {
  const { featuresLoaded } = useAuth();
  const location = useLocation();

  if (!authSession.hasSession()) {
    return <Navigate to={buildLoginPath(location)} replace />;
  }

  if (!featuresLoaded) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Spinner size="lg" />
      </div>
    );
  }

  if (!featuresService.hasFeature("read:back-office")) {
    return <Navigate to={DashboardRoutes.DASHBOARD} replace />;
  }

  return <Outlet />;
};
